/**
 * contains errorcodes to handle server error or url issues
 *
**/

export enum ErrorHandlerCodesEnum {
  NOT_FOUND = 404,
  FORBIDDEN = 403,
}
